import { useInfiniteQuery, useQuery } from '@tanstack/react-query';

import { locationsApi } from '../axios/locations';
import { Location } from '../types';

export function useLocationsInfiniteQuery(searchQuery: string) {
  return useInfiniteQuery({
    queryKey: ['locations', searchQuery],
    queryFn: ({ pageParam = 1 }) => locationsApi.getLocationsWithSearch(pageParam, searchQuery),
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.pages) {
        return lastPage.page + 1;
      }
      return undefined;
    },
    getPreviousPageParam: (firstPage) => {
      if (firstPage.page > 1) {
        return firstPage.page - 1;
      }
      return undefined;
    },
    initialPageParam: 1,
  });
}

export function useLocationQuery(locationId: Location['id']) {
  return useQuery({
    queryKey: ['location', locationId],
    queryFn: () => locationsApi.getLocation(locationId),
    enabled: !!locationId,
  });
}

export function useLocationsByIdsQuery(locationIds: number[]) {
  return useQuery({
    queryKey: ['locationsByIds', locationIds?.sort((a, b) => a - b)],
    queryFn: () => locationsApi.getLocationsByIds(locationIds?.join(',') ?? ''),
    enabled: !!locationIds && locationIds.length > 0,
  });
}
